export const initAventraVideoModals = (): void => {
  const triggers = document.querySelectorAll<HTMLElement>(
    ".aventra-video-trigger",
  );

  const getEmbedUrl = (url: string): string => {
    if (url.includes("youtube.com") || url.includes("youtu.be")) {
      const id = url.split("v=")[1] || url.split("/").pop();
      return `https://www.youtube.com/embed/${id}?autoplay=1`;
    }
    if (url.includes("vimeo.com")) {
      const id = url.split("/").pop();
      return `https://player.vimeo.com/video/${id}?autoplay=1`;
    }
    return url;
  };

  triggers.forEach((trigger) => {
    trigger.addEventListener("click", (e) => {
      e.preventDefault();
      const modalId = trigger.dataset.modalId;
      const videoUrl = trigger.dataset.videoUrl;
      const modal = document.getElementById(modalId || "");

      if (modal && videoUrl) {
        const container = modal.querySelector(".video-container");
        const embedUrl = getEmbedUrl(videoUrl);

        if (container) {
          // We don't need to put styles here if they are in the SCSS file above
          container.innerHTML = `<iframe 
        src="${embedUrl}" 
        allow="autoplay; fullscreen; picture-in-picture" 
        allowfullscreen></iframe>`;
        }

        modal.style.display = "flex";
        document.body.style.overflow = "hidden"; // Prevent scroll
      }
    });
  });

  // Close logic
  document.querySelectorAll(".aventra-video-modal").forEach((modal) => {
    const closeBtn = modal.querySelector(".close-btn");
    const closeModal = () => {
      (modal as HTMLElement).style.display = "none";
      const container = modal.querySelector(".video-container");
      if (container) container.innerHTML = ""; // Stop video
      document.body.style.overflow = "";
    };

    closeBtn?.addEventListener("click", closeModal);
    modal.addEventListener("click", (e) => {
      if (e.target === modal) closeModal();
    });
  });
};
